module.exports = __webpack_public_path__ + "img/logo-icon.76e86438.png";